function capitalizeWords(str: string): string {
  if (!str) return ''
  return str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}
const Pura = (window as any).Pura || { collection: { title_map: {} } }

const updateFilterKey: { [key: string]: string } = {
  collectionfilter: 'CollectionFilter',
  'scent-type': 'Scent_Type',
  group: 'Group',
  brand: 'brand',
  mood: 'Mood',
  strength: 'Strength',
}

export function parseFilters(
  filters: string | null | undefined
): Array<{ key: string; values: string[] }> {
  if (!filters) return []

  const appliedFilters = filters.split('+').map((filter) => {
    let data: string[]
    const collectionTitleMap = Pura?.collection?.title_map || {}

    if (filter.toLowerCase().startsWith('brand-')) {
      const dashIndex = filter.indexOf('-')
      data =
        dashIndex !== -1
          ? [filter.substring(0, dashIndex), filter.substring(dashIndex + 1)]
          : [filter]
    } else {
      data = filter.split('_')
    }

    let key =
      data[0].toLowerCase() === 'brand'
        ? data[0]
        : capitalizeWords(data[0]).replace(/ /g, '_')
    key = updateFilterKey[key.toLowerCase()] || key

    let value =
      data.length > 1
        ? capitalizeWords(data.slice(1).join('_')).replace(/-/g, ' ')
        : ''
    value = collectionTitleMap[value] || value

    return {
      key: key,
      values: [value],
    }
  })

  return appliedFilters
}
